module.exports = __webpack_public_path__ + "static/media/da-about-2.b60470ed.jpg";